import api from '@/services/api/api';
import { useQuery } from '@tanstack/react-query';

function useGetOrganizationServices(organizationId: string) {
  return useQuery({
    queryKey: ['services', organizationId],
    queryFn: () => api.services.getOrganization(organizationId)
  });
}

export default useGetOrganizationServices;
